module.exports = __webpack_public_path__ + "static/media/SequoiaGreenToken-Whitepaper.cc6b9bd9.pdf";